import React, { useState, useEffect } from 'react';
import { useSiteSettings } from '../hooks/useSiteSettings';
import axios from 'axios';

function SetupWizard({ onComplete }) {
  const brand = useSiteSettings();
  const [step, setStep] = useState(1);
  const [industry, setIndustry] = useState(null);
  const [branchData, setBranchData] = useState({
    name: '',
    phone: '',
    email: '',
    city: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleIndustrySelect = (selected) => {
    setIndustry(selected);
    setStep(2);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const token = localStorage.getItem('crm_token');
      const savedUser = JSON.parse(localStorage.getItem('crm_user') || '{}');
      const branchId = savedUser.branch_id;
      if (!branchId) {
        throw new Error('Şube bilgisi bulunamadı, lütfen tekrar giriş yapın.');
      }

      // Update branch with industry
      await axios.put(`/api/branches/${branchId}`, {
        ...branchData,
        industry
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      onComplete(industry);
    } catch (err) {
      setError(err.response?.data?.error || 'Bir hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="setup-wizard">
      <div className="setup-container">
        <div className="setup-header">
          <div className="setup-logo">
            <div className="logo-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
              </svg>
            </div>
            <h1>{brand.site_name || 'CRM'}</h1>
          </div>
        </div>

        {step === 1 && (
          <div className="setup-step">
            <h2>Hoş Geldiniz! 👋</h2>
            <p className="setup-subtitle">Hangi sektörde faaliyet gösteriyorsunuz?</p>
            
            <div className="industry-grid">
              <div 
                className="industry-card"
                onClick={() => handleIndustrySelect('beauty_salon')}
              >
                <div className="industry-icon">💅</div>
                <h3>Güzellik Salonu</h3>
                <p>Saç, makyaj, cilt bakımı, manikür pedikür</p>
                <div className="industry-features">
                  <span>✓ Randevu Yönetimi</span>
                  <span>✓ Müşteri Takibi</span>
                  <span>✓ POS & Stok</span>
                </div>
              </div>

              <div 
                className="industry-card"
                onClick={() => handleIndustrySelect('bridal_shop')}
              >
                <div className="industry-icon">👗</div>
                <h3>Gelinlikçi & Abiye</h3>
                <p>Gelinlik, abiye, damatlık satış ve kiralama</p>
                <div className="industry-features">
                  <span>✓ Ölçü Kartı</span>
                  <span>✓ Prova Takvimi</span>
                  <span>✓ Kiralama Sistemi</span>
                  <span>✓ Atölye Yönetimi</span>
                </div>
              </div>

              <div 
                className="industry-card"
                onClick={() => handleIndustrySelect('health_tourism')}
              >
                <div className="industry-icon">🏥</div>
                <h3>Sağlık Turizmi</h3>
                <p>Yurtdışı hasta koordinasyonu ve tedavi yönetimi</p>
                <div className="industry-features">
                  <span>✓ Hasta Takibi</span>
                  <span>✓ 7/24 İletişim</span>
                  <span>✓ Çok Dilli Destek</span>
                </div>
              </div>

              <div 
                className="industry-card"
                onClick={() => handleIndustrySelect('hotel')}
              >
                <div className="industry-icon">🏨</div>
                <h3>Otelcilik</h3>
                <p>Otel, pansiyon ve konaklama işletmeleri</p>
                <div className="industry-features">
                  <span>✓ Rezervasyon</span>
                  <span>✓ Misafir İletişimi</span>
                  <span>✓ Çok Dilli Karşılama</span>
                </div>
              </div>

              <div 
                className="industry-card"
                onClick={() => handleIndustrySelect('dental_clinic')}
              >
                <div className="industry-icon">🦷</div>
                <h3>Diş Hekimliği</h3>
                <p>Diş klinikleri ve muayenehaneleri</p>
                <div className="industry-features">
                  <span>✓ Randevu Hatırlatma</span>
                  <span>✓ Tedavi Takibi</span>
                  <span>✓ Diş Haritası</span>
                </div>
              </div>

              <div 
                className="industry-card"
                onClick={() => handleIndustrySelect('clinic')}
              >
                <div className="industry-icon">🩺</div>
                <h3>Klinik & Hastane</h3>
                <p>Özel klinikler ve hastaneler</p>
                <div className="industry-features">
                  <span>✓ Randevu Yönetimi</span>
                  <span>✓ Hasta Memnuniyeti</span>
                  <span>✓ Otomatik Hatırlatma</span>
                </div>
              </div>

              <div 
                className="industry-card"
                onClick={() => handleIndustrySelect('ecommerce')}
              >
                <div className="industry-icon">🛒</div>
                <h3>E-ticaret</h3>
                <p>Online mağaza ve e-ticaret işletmeleri</p>
                <div className="industry-features">
                  <span>✓ Sipariş Takibi</span>
                  <span>✓ Müşteri Desteği</span>
                  <span>✓ İade Yönetimi</span>
                </div>
              </div>
            </div>
          </div>
        )}

        {step === 2 && (
          <form className="setup-step" onSubmit={handleSubmit}>
            <h2>Salon Bilgileri</h2>
            <p className="setup-subtitle">{industry === 'beauty_salon' ? 'Güzellik salonunuz' : 'Mağazanız'} hakkında bilgiler</p>

            <div className="form-grid">
              <div className="form-group">
                <label className="form-label">
                  {industry === 'beauty_salon' ? 'Salon Adı' : 'Mağaza Adı'}
                </label>
                <input 
                  type="text" 
                  className="input"
                  value={branchData.name}
                  onChange={(e) => setBranchData({...branchData, name: e.target.value})}
                  placeholder={industry === 'beauty_salon' ? 'Güzellik Salonu' : 'Gelinlikçi Butik'}
                  required
                />
              </div>

              <div className="form-group">
                <label className="form-label">Telefon</label>
                <input 
                  type="tel" 
                  className="input"
                  value={branchData.phone}
                  onChange={(e) => setBranchData({...branchData, phone: e.target.value})}
                  placeholder="+90 212 123 4567"
                  required
                />
              </div>

              <div className="form-group">
                <label className="form-label">E-posta</label>
                <input 
                  type="email" 
                  className="input"
                  value={branchData.email}
                  onChange={(e) => setBranchData({...branchData, email: e.target.value})}
                  placeholder="info@salon.com"
                  required
                />
              </div>

              <div className="form-group">
                <label className="form-label">Şehir</label>
                <input 
                  type="text" 
                  className="input"
                  value={branchData.city}
                  onChange={(e) => setBranchData({...branchData, city: e.target.value})}
                  placeholder="İstanbul"
                  required
                />
              </div>
            </div>

            {error && <div className="login-error">{error}</div>}

            <div className="setup-actions">
              <button type="button" className="btn btn-ghost" onClick={() => setStep(1)}>
                ← Geri
              </button>
              <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? 'Kaydediliyor...' : 'Devam Et →'}
              </button>
            </div>
          </form>
        )}

        <div className="setup-progress">
          <div className={`progress-dot ${step >= 1 ? 'active' : ''}`}></div>
          <div className="progress-line"></div>
          <div className={`progress-dot ${step >= 2 ? 'active' : ''}`}></div>
        </div>
      </div>

      <style>{`
        .setup-wizard {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);
          padding: 20px;
        }
        .setup-container {
          background: white;
          border-radius: 24px;
          padding: 48px;
          width: 100%;
          max-width: 900px;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
        }
        .setup-header {
          text-align: center;
          margin-bottom: 40px;
        }
        .setup-logo {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 16px;
          margin-bottom: 16px;
        }
        .setup-logo .logo-icon {
          width: 56px;
          height: 56px;
          background: linear-gradient(135deg, var(--tertiary) 0%, #ec4899 100%);
          border-radius: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .setup-logo .logo-icon svg {
          width: 28px;
          height: 28px;
          color: white;
        }
        .setup-logo h1 {
          font-size: 32px;
          font-weight: 700;
          color: #1e293b;
          margin: 0;
        }
        .setup-step h2 {
          font-size: 28px;
          font-weight: 700;
          text-align: center;
          margin-bottom: 8px;
          color: #1e293b;
        }
        .setup-subtitle {
          text-align: center;
          color: #64748b;
          font-size: 16px;
          margin-bottom: 32px;
        }
        .industry-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 20px;
        }
        .industry-card {
          padding: 32px 24px;
          background: #f8fafc;
          border: 2px solid #e2e8f0;
          border-radius: 16px;
          cursor: pointer;
          transition: all 0.2s;
          text-align: center;
        }
        .industry-card:hover {
          border-color: var(--tertiary);
          transform: translateY(-4px);
          box-shadow: 0 12px 24px -8px rgba(var(--tertiary-rgb), 0.25);
        }
        .industry-icon {
          font-size: 56px;
          margin-bottom: 16px;
        }
        .industry-card h3 {
          font-size: 20px;
          font-weight: 600;
          margin-bottom: 8px;
          color: #1e293b;
        }
        .industry-card p {
          font-size: 14px;
          color: #64748b;
          margin-bottom: 16px;
        }
        .industry-features {
          display: flex;
          flex-direction: column;
          gap: 6px;
          font-size: 13px;
          color: #10b981;
        }
        .form-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 20px;
        }
        .setup-actions {
          display: flex;
          justify-content: space-between;
          margin-top: 32px;
        }
        .setup-progress {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 40px;
        }
        .progress-dot {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: #e2e8f0;
        }
        .progress-dot.active {
          background: var(--tertiary);
        }
        .progress-line {
          width: 60px;
          height: 2px;
          background: #e2e8f0;
          margin: 0 12px;
        }
        @media (max-width: 640px) {
          .industry-grid, .form-grid {
            grid-template-columns: 1fr;
          }
          .setup-container {
            padding: 32px 24px;
          }
        }
      `}</style>
    </div>
  );
}

export default SetupWizard;
